import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { fetchCompanies, showUpdateCompanyForm, deleteCompany, changePage } from '../actions/companies.js'
import { fetchBuildings } from '../actions/buildings.js'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {Card, CardText} from 'material-ui/Card';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import ConfirmButton from 'material-ui-confirm-button';
import Delete from 'material-ui/svg-icons/action/delete';
import Edit from 'material-ui/svg-icons/image/edit';
import Pagination from 'material-ui-pagination';

import AddCompany from '../components/companies/AddCompany'

const style = {
  marginBottom: 10,
};

const iconStyle = {
  margin: 0,
  padding: 0,
  minWidth: 0,
  width: 50,
};

class Companies extends Component {

  static defaultProps = {

    pageNumber: 1,
    itemsPerPage: 50,
    paginationDisplay: 10
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    this.fetchPageCompanies()
    dispatch(fetchBuildings())
    document.title = "Companies - Admin - Better Spaces"
  }

  componentDidUpdate() {
    if (this.props.pageChanged) {
      this.fetchPageCompanies()
    }
  }

  fetchPageCompanies() {
    const { dispatch } = this.props
    dispatch(fetchCompanies(
      (this.props.pageNumber - 1) * (this.props.itemsPerPage),
      this.props.itemsPerPage))
  }

  showAddCompanyForm() {
    const { dispatch } = this.props
    dispatch(showUpdateCompanyForm({buildings: []}))
  }

  updateCompany(company) {
    const { dispatch } = this.props
    dispatch(showUpdateCompanyForm(company))
  }

  deleteCompany(company) {
    const { dispatch } = this.props
    dispatch(deleteCompany(company))
  }

  onPageChanged(newPageNumber) {
    const { dispatch } = this.props
    if (newPageNumber != this.props.pageNumber)
      dispatch(changePage(newPageNumber))
  }

  render() {

    if (this.props.companiesFetched && this.props.buildingsFetched) {
      if (this.props.companies && this.props.companies.length > 0) {

        this.props.companies.sort(function(a, b) {
          if(a.name < b.name) return -1;
          if(a.name > b.name) return 1;
          return 0;
        });

        return (
          <div>
            <AddCompany />
            {
              this.props.role.length > 4 && this.props.role.charAt(4) == '2'
              ? (<RaisedButton label="Add Company" primary={true} style={style} onClick={this.showAddCompanyForm.bind(this)}/>)
              : null
            }

            <br /> <br />

            <Pagination
                total={Math.ceil(this.props.companiesCount / this.props.itemsPerPage)}
                current={this.props.pageNumber}
                display={this.props.paginationDisplay}
                onChange={this.onPageChanged.bind(this)}
            />

            <Table selectable={false} style={{tableLayout: 'auto'}} fixedHeader={false}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                  <TableRow>
                    <TableHeaderColumn style={{width: '3%'}}>ID</TableHeaderColumn>
                    <TableHeaderColumn style={{width: '20%'}}>Name</TableHeaderColumn>
                    <TableHeaderColumn style={{width: '30%'}}>Buildings</TableHeaderColumn>
                    <TableHeaderColumn style={{width: '32%'}}>Domains</TableHeaderColumn>
                    <TableHeaderColumn style={{width: '15%'}}></TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                  {this.props.companies.map((company, index) =>
                    <TableRow>
                      <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '3%'}}>{company.index}</TableRowColumn>
                      <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '30%'}}>{company.name}</TableRowColumn>
                      <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '50%'}}>{company.buildings.map(building => building.name).join()}</TableRowColumn>
                      <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '50%'}}>{company.domains.join()}</TableRowColumn>

                      {this.props.role.length > 4 && this.props.role.charAt(4) == '2' ? (<TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal', width: '15%'}}>
                        <FlatButton icon={<Edit />} style={iconStyle} primary={true} onClick={this.updateCompany.bind(this, company)}/>
                        <ConfirmButton key={company._id} isFlat={true} style={iconStyle} icon={<Delete />} confirmMessage="	&#10004;" cancelMessage="X" secondary={true} onSubmit={this.deleteCompany.bind(this, company)} />
                      </TableRowColumn>):(<TableRowColumn/>)}
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              <Pagination
                  total={Math.ceil(this.props.companiesCount / this.props.itemsPerPage)}
                  current={this.props.pageNumber}
                  display={this.props.paginationDisplay}
                  onChange={this.onPageChanged.bind(this)}
              />
          </div>
        )
      } else {
        return(
          <div>
          {this.props.role.length > 4 && this.props.role.charAt(4) == '2' ? (<RaisedButton label="Add Company" primary={true} style={style} onClick={this.showAddCompanyForm.bind(this)}/>) : (<div/>)}

          <Card style={{width: '100%', height: '100%'}}>
            <CardText style={{position: 'relative', width: '100%', height: '100%'}}>
              No Companies
            </CardText>
            </Card>
          </div>)
      }
    } else {
      return(
        <Card style={{width: '100%', height: '100%'}}>
          <CardText style={{position: 'relative', width: '100%', height: '100%'}}>
            <CircularProgress size={80} thickness={5} style={{marginLeft: '50%'}} />
          </CardText>
        </Card>
        )
    }
  }
}

const mapStateToProps = state => {

  const { isFetching } = state.companiesReducer

  if (isFetching) {
    return {
      isFetching
    }
  } else {
    return {
      ...state.companiesReducer,
      role: state.usersReducer.role
    }
  }
}

export default withRouter(
    connect(mapStateToProps)(Companies)
);



// WEBPACK FOOTER //
// ./src/containers/Companies.js